import { useAuth } from "@/hooks/auth";
import { Navigate, Outlet } from "react-router-dom";

const AuthStandaloneRoute = () => {
    const { isAuthenticated } = useAuth();

    if (isAuthenticated) {
        return <Outlet />;
    }

    return <Navigate to={`/login?redirect=/set-password`} />;
};

export default AuthStandaloneRoute;
